import TimeOfDayDetails from './rates/timeOfDayDetails';
import timeOfDayService from './rates/timeOfDayService';
import timeOfDayServiceDiscount from './rates/timeOfDayServiceDiscount';
import fixedService from './rates/fixedService';
import R14Details from './rates/r14Details';
import TimeOfDayEVDetails from './rates/timeOfDayEVDetails';

//OBS: For the rates data, the max and min ALWAYS need to have 12 elements.
const rates = {
  TOD: {
    id: 'TOD',
    title: ['rates.tod.title'],
    subTitle: [''],
    data: timeOfDayService,
    detailsComponent: TimeOfDayDetails,
  },
  R14: {
    id: 'R14',
    title: ['rates.fixed.title'],
    subTitle: [''],
    data: fixedService,
    detailsComponent: R14Details,
  },
  DIS: {
    id: 'DIS',
    title: ['rates.tod.evdiscount.title'],
    subTitle: [''],
    data: timeOfDayServiceDiscount,
    detailsComponent: TimeOfDayEVDetails,
  },
};

export default rates;
